export default {
  saveCarDetails({ commit, state }, { product, make, bodyType }) {
    commit('clearCarVariant');
    commit('clearLeaseDetails');
    commit('clearColourAndExtras');
    commit('clearCustomerDetails');
    commit('setErpQuoteFields', { product, make, bodyType });
  },
  saveCarVariant({ commit, state }, { model, variant }) {
    commit('clearLeaseDetails');
    commit('clearColourAndExtras');
    commit('clearCustomerDetails');
    commit('setErpQuoteFields', { model, variant });
  },
  saveLeaseDetails(
    { commit, state },
    {
      leaseTerm,
      availableOptions,
      kmsPerYear,
      leaseStart,
      leaseEnd,
      dbQuoteId,
      dbStatus,
      erpQuoteRef,
      erpStatus,
      price
    }
  ) {
    commit('setDbQuoteFields', {
      id: dbQuoteId,
      quote_status_code: dbStatus
    });
    commit('setErpQuoteFields', {
      leaseTerm,
      availableOptions,
      kmsPerYear,
      leaseStart,
      leaseEnd,
      erpQuoteRef,
      status: erpStatus,
      price
    });
  },
  saveColourAndExtras(
    { commit, state },
    {
      exteriorColour,
      interiorColour,
      optionalEquipment,
      adhocEquipment,
      erpQuoteRef,
      erpStatus,
      price
    }
  ) {
    commit('setErpQuoteFields', {
      exteriorColour,
      interiorColour,
      optionalEquipment,
      adhocEquipment,
      erpQuoteRef,
      status: erpStatus,
      price
    });
    commit('setErpQuotePriceFields', price);
  },
  saveCustomerDetails(
    { commit, state },
    { customer, dbQuoteId, dbStatus, erpQuoteRef, erpStatus, price }
  ) {
    commit('setDbQuoteFields', {
      id: dbQuoteId,
      quote_status_code: dbStatus
    });
    commit('setErpQuoteFields', {
      customer,
      erpQuoteRef,
      status: erpStatus,
      price
    });
  }
};
